export default __webpack_public_path__ + "static/media/userId.7050b0ce.svg";